<template lang="html">
  <v-container>
    <v-article-paper>
      <v-paragraph>
          这是skyTNT的个人网站
      </v-paragraph>
    </v-article-paper>
  </v-container>
</template>

<script>
export default {
  name:"AboutPage"
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/AboutPage.vue